module.exports = __webpack_public_path__ + "img/processing.973d88ac.png";